module.exports = insights;